import { AnalyticsGroupDto } from '@api/models/analytics/AnalyticsGroupDto';

const numValue = (g: AnalyticsGroupDto, valueKey: string): number => {
  const n = Number(g.values?.[valueKey]);
  return Number.isFinite(n) ? n : 0;
};

/**
 * Groups sorted by metric value, highest first. Callers skip time groupings
 * (hour/day/week/month) — those must stay in chronological order.
 */
export const sortGroupsByValueDesc = (groups: AnalyticsGroupDto[], valueKey: string): AnalyticsGroupDto[] =>
  [...groups].sort((a, b) => numValue(b, valueKey) - numValue(a, valueKey));
